/*
 * Açılış döneri: kök `Suspense` (main.tsx) ve kimlik ekranlarının tembel parçası (App.tsx
 * `AuthScreen`) AYNI kareyi çizer. Kimlik bağlantısıyla gelen ziyaretçi kabuk parçası indikten
 * sonra ekran parçasını beklerken dönerin yerinde kaldığını görür; boş ya da farklı bir kare yok.
 * Giriş paketindedir (main.tsx statik içe aktarır), kabuk parçasına bayt eklemez.
 */
/**
 * Kök `Suspense`in geri dönüşü. `App` artık tembel olduğu için kabuğun parçası entry betiği
 * çalışıp `import()`u tetikleyene KADAR inmeye başlamaz — `modulepreload` ile paralel inen
 * eski hâlin aksine gerçek bir ek ağ turu var (Task 13 fix round 2, bulgu 1). Geri dönüş
 * `null` olursa `#app` boş kalır ve OTURUMLU her ziyaretçi (giriş ekranı dâhil) bu turu boş,
 * temasız bir kare olarak görür. `UI.Skeleton` kullanılamaz: tam da erteliğimiz kabuk
 * paketinin içinde yaşıyor. Bu yüzden kabuktan bağımsız, kendi kendine yeten minimal bir
 * döner — kabuğun kendisi gelince aynı kareyi DEĞİŞTİRİR, üstüne binmez ya da kayma yapmaz.
 * Sınıf `pages.css`e eklenmez (paylaşımlı dosya, başka görev az önce dokundu); zaten yüklü
 * katmanların (`layers.css`) tanımladığı token'larla kendi `<style>` etiketini taşır.
 */
export function BootFallback() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
      }}
    >
      {/* reduced-motion.css "yükleniyor (spin, pulse)"i durum bildiren hareket sayıp
          korur (bkz. dosyanın üst yorumu) — bu döner de aynı kategoridedir, ayrı bir
          @media kuralı gerekmez. */}
      <div
        aria-hidden="true"
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: '3px solid var(--line)',
          borderTopColor: 'var(--accent)',
          animation: 'dentos-boot-spin 0.8s linear infinite',
        }}
      />
      <style>{'@keyframes dentos-boot-spin { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}
